<div class="forwarding-form-config">
  <a routerLink="/admin/forwarding" class="mb-4 is-inline-block">
    &larr; {{ 'admin.forwarding.backToDashboard' | localize }}
  </a>

  <h1 class="title">{{ 'admin.forwarding.config.title' | localize }}</h1>

  @if (loading) {
    <div class="has-text-centered p-5">
      <span class="loader"></span>
      <p>{{ 'admin.forwarding.loading' | localize }}</p>
    </div>
  } @else {
    @if (error) {
      <div class="notification is-danger">
        {{ error }}
      </div>
    }

    @if (successMessage) {
      <div class="notification is-success">
        {{ successMessage }}
      </div>
    }

    @if (status) {
      <h2 class="subtitle">{{ 'admin.forwarding.counter.title' | localize }}</h2>

      <div class="columns">
        <div class="column is-one-third">
          <div class="box has-text-centered">
            <p class="heading">{{ 'admin.forwarding.counter.date' | localize }}</p>
            <p class="title is-5">{{ status.counter.date }}</p>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="box has-text-centered">
            <p class="heading">{{ 'admin.forwarding.counter.count' | localize }}</p>
            <p class="title is-5">{{ status.counter.count }}</p>
          </div>
        </div>
        <div class="column is-one-third">
          <div class="box has-text-centered">
            <p class="heading">{{ 'admin.forwarding.counter.limit' | localize }}</p>
            <p class="title is-5">{{ status.counter.dailyLimit }}</p>
          </div>
        </div>
      </div>

      <div class="buttons mb-5">
        <button class="button is-warning" (click)="onResetCounter()" [disabled]="saving">
          {{ 'admin.forwarding.counter.reset' | localize }}
        </button>
      </div>

      <h2 class="subtitle">{{ 'admin.forwarding.config.title' | localize }}</h2>

      <form [formGroup]="configForm" (ngSubmit)="onSave()">
        <div class="field">
          <label class="label">{{ 'admin.forwarding.config.dailyLimit' | localize }}</label>
          <div class="control">
            <input class="input" type="number" formControlName="dailyLimit">
          </div>
        </div>

        <div class="field">
          <label class="label">{{ 'admin.forwarding.config.maxRetries' | localize }}</label>
          <div class="control">
            <input class="input" type="number" formControlName="maxRetries">
          </div>
        </div>

        <div class="field">
          <label class="label">{{ 'admin.forwarding.config.batchSize' | localize }}</label>
          <div class="control">
            <input class="input" type="number" formControlName="batchSize">
          </div>
        </div>

        <div class="field">
          <label class="checkbox">
            <input type="checkbox" formControlName="isEnabled">
            {{ 'admin.forwarding.config.isEnabled' | localize }}
          </label>
        </div>

        <div class="field">
          <div class="control">
            <button class="button is-primary" type="submit" [disabled]="saving">
              @if (saving) {
                {{ 'admin.forwarding.config.saving' | localize }}
              } @else {
                {{ 'admin.forwarding.config.save' | localize }}
              }
            </button>
          </div>
        </div>
      </form>
    }
  }
</div>
